
import { ListItem } from '../../../shared/list-confirmation/model/list-item';

export class ReportIncomeModel {
	year: string;

	success?: boolean;
	message?: string;
	resumeList?: Array<ListItem>;

	constructor() { }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/report-income/models/report-income.ts